import { ifitBlack, ifitBlack54, scienceBlue } from '../../../theme/colors';

export default {
  modal: {
    width: '85%',
    maxWidth: 'none'
  },
  modalLabel: {
    fontFamily: 'proxima-nova',
    fontWeight: 600,
    letterSpacing: '0.05rem',
    color: scienceBlue
  },
  title: {
    color: ifitBlack,
    fontFamily: 'proxima-nova',
    fontWeight: 600,
    marginBottom: '0',
    paddingBottom: '0'
  },
  content: {
    color: ifitBlack54,
    fontFamily: 'proxima-nova',
    lineHeight: 1.5
  }
};
